import request from '@/utils/request'
import { keysIn } from 'lodash'
import { EXTRA_FIELD, TOTAL_VALUE } from '@antv/s2'

// 当月&YTD
const jianminSendOut = {
  'trackId': 'jianminSendOut',
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [],
      'columns': [
        {
          'field': 'monthAmount',
          'name': '当月',
          'format': {
            'magnitude': 'tenThousand',
            'suffix': '元',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'yearAmount',
          'name': '全年完成',
          'format': {
            'magnitude': 'tenThousand',
            'suffix': '元',
            'thousandsSeparatorFlag': true
          }
        }
      ]
    }
  ]
}
// 同比去年
// eslint-disable-next-line camelcase
const YearAmount_YOY_R = {
  'trackId': 'YearAmount_YOY_R',
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [],
      'columns': [
        {
          'field': 'yearAmount',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 2
          }
        }
      ]
    }
  ]
}
// 全年进度
const yearPercent = {
  'trackId': 'yearPercent',
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [],
      'columns': [
        {
          'field': 'yearPercent',
          'name': '全年进度',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ]
    }
  ]
}
// 产品表格
const kaProduct = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [
        {
          'field': 'productBrand',
          'name': 'KA产品',
          'format': {
            'emptyValue': '-'
          }
        }
      ],
      'columns': [
        {
          'field': 'monthAmount',
          'name': '当月',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        },
        {
          'field': 'monthAmount',
          'ratio': 'LINK',
          'name': '环比上月',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearAmount',
          'name': '全年完成',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearAmount',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 0,
            'emptyValue': '-'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true,
            'position': 'Bottom',
            'name': 'KA合计'
          }
        }
      },
      'sortParams': [
        {
          'sortFieldId': 'productBrand',
          'sortBy': ['60袋龙牡', '108粒便通', '48粒便通', '45片咽喉片', '24片咽喉片', 'KA其他']
        }
      ]
    }
  ]
}

// 产品表格
const businessProduct = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [
        {
          'field': 'productBrand',
          'name': '商务产品'
        }
      ],
      'columns': [
        {
          'field': 'monthAmount',
          'name': '当月',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        },
        {
          'field': 'monthAmount',
          'ratio': 'LINK',
          'name': '环比上月',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearAmount',
          'name': '全年完成',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearAmount',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 0,
            'emptyValue': '-'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true,
            'position': 'Bottom',
            'name': 'KA合计'
          }
        }
      },
      'sortParams': [
        {
          'sortFieldId': 'productBrand',
          'sortBy': ['30袋龙牡', '24粒便通', '16片咽喉片', '商务其他']
        }
      ]
    }
  ]
}

// 产品表格
const attractInvestmentProduct = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [
        {
          'field': 'productBrand',
          'name': '招商产品'
        }
      ],
      'columns': [
        {
          'field': 'monthAmount',
          'name': '当月',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        },
        {
          'field': 'monthAmount',
          'ratio': 'LINK',
          'name': '环比上月',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearAmount',
          'name': '全年完成',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearAmount',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 0,
            'emptyValue': '-'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true,
            'position': 'Bottom',
            'name': 'KA合计'
          }
        }
      },
      'sortParams': [
        {
          'sortFieldId': 'productBrand',
          'sortBy': [
            '招商'
          ]
        }
      ],
      'filters': [
        {
          'field': 'date',
          'mode': '=',
          'values': [
            '2023-01-31'
          ]
        },
        {
          'field': 'stdSellerBusinessTypeTag',
          'mode': '=',
          'values': [
            'jianminGroupFlag'
          ]
        },
        {
          'field': 'productLine',
          'mode': '=',
          'values': [
            '招商产品'
          ]
        }
      ]
    }
  ]
}
// 销售公司
const saleCompany = {
  'widgetType': 'line',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [
        {
          'field': 'dept',
          'name': '销售公司'
        }
      ],
      'columns': [
        {
          'field': 'yearAmount',
          'name': '去年同期',
          'ratio': 'YOY.V',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'yearAmount',
          'name': '全年完成',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'targetAmount',
          'name': '目标',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true
          }
        }
      ]
    }
  ]
}

const saleCompanyTable = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [
        {
          'field': 'dept',
          'name': '销售公司'
        }
      ],
      'columns': [
        {
          'field': 'yearAmount',
          'name': '全年完成',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'targetAmount',
          'name': '目标',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'yearPercent',
          'name': '全年进度',
          'format': {
            'magnitude': 'percentage'
          }
        },
        {
          'field': 'yearAmount',
          'name': '去年同期',
          'ratio': 'YOY.V',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'yearAmount',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ]
    }
  ]
}

// 黄金单品 堆叠柱状图
const productPercent = {
  'trackId': 'productPercent',
  'widgetType': 'bar',
  'cubes': [
    {
      'cubeId': '525a012d-022e-4d7e-964f-64acb538f8a6',
      'rows': [
        {
          'field': 'year',
          'name': '年'
        }
      ],
      'columns': [
        {
          'field': 'salesAmount',
          'name': '销售金额',
          'format': {
            'magnitude': 'tenThousand',
            'suffix': '元',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'product',
          'name': '产品'
        }
      ],
      sortParams: [
        { 'sortFieldId': 'product', 'sortBy': ['60袋龙牡', '30袋龙牡'] }
      ]
    }
  ]
}

// 黄金单品 占比
const productList = {
  'widgetType': 'pie',
  'cubes': [
    {
      'cubeId': '7ffb2a93-9041-4070-b8b6-48b55c129687',
      'rows': [
        {
          'field': 'product',
          'name': '产品'
        }
      ],
      'columns': [
        {
          'field': 'yearAmount',
          'name': '销售金额',
          'format': {
            'magnitude': 'tenThousand',
            'suffix': '元',
            'thousandsSeparatorFlag': true
          }
        }
      ],
      'orders': [
        {
          field: 'yearAmount',
          mode: 'DESC'
        }
      ]
    }
  ]
}

// 黄金单品 表格
const productTable = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '7ffb2a93-9041-4070-b8b6-48b55c129687',
      'rows': [{ 'field': 'product', 'name': '黄金单品' }],
      'columns': [
        {
          'field': 'salesAmount',
          'name': '当月',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        },
        {
          'field': 'salesAmount',
          'ratio': 'LINK',
          'name': '环比上月',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearAmount',
          'name': '全年完成',
          'format': {
            'magnitude': 'tenThousand',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearAmount',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 0,
            'emptyValue': '-'
          }
        },
        {
          'field': 'yearPercent',
          'name': '全年进度',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 0,
            'emptyValue': '-'
          }
        }
      ],
      'sortParams': [
        {
          'sortFieldId': 'product',
          'sortBy': ['60袋龙牡', '30袋龙牡', '便通胶囊', '咽喉片', 'KA其他', '商务其他']
        }
      ]
    }
  ]
}

// 覆盖率
const coveredPercent = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [],
      'columns': [
        {
          'field': 'coveredPercent',
          'name': '覆盖率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ]
    }
  ]
}
// 总部覆盖数
const coveredNumber = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [],
      'columns': [
        {
          'field': 'coveredClientNum',
          'name': '总部覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        }
      ]
    }
  ]
}

// 单体覆盖数
const storeCoveredNumber = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [],
      'columns': [
        {
          'field': 'coveredClientNum',
          'name': '单体覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        }
      ]
    }
  ]
}

// 门店覆盖数
const storesCoveredNumber = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [],
      'columns': [
        {
          'field': 'coveredClientNum',
          'name': '门店覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true,
            'emptyValue': '-'
          }
        }
      ]
    }
  ]
}
// 覆盖列表
const coverList = {
  'widgetType': 'bar',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [
        {
          'field': 'dept',
          'name': '销售公司'
        }
      ],
      'columns': [
        {
          'field': 'coveredClientNum',
          'name': '覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'coveredPercent',
          'name': '覆盖率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ]
    }
  ]
}
// 铺货数
const distributionNum = {
  'widgetType': 'bar',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'dept',
          'name': '部门'
        }
      ],
      'columns': [
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ]
    }
  ]
}

// 达标数
const standardsNum = {
  'widgetType': 'bar',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'dept',
          'name': '部门'
        }
      ],
      'columns': [
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 2
          }
        }
      ]
    }
  ]
}

// 铺货指标
const distributionIndicators = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        }
      ],
      'columns': [
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 2
          }
        }
      ]
    }
  ]
}

const distributionIndicatorsNum = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [],
      'columns': [
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        }
      ]
    }
  ]
}

const distributionIndicatorsPercent = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [],
      'columns': [
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 2
          }
        }
      ]
    }
  ]
}

// 达标指标
const standardsIndicators = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        }
      ],
      'columns': [
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 2
          }
        }
      ]
    }
  ]
}

// 达标指标
const standardsIndicatorsNum = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [],
      'columns': [
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        }
      ]
    }
  ]
}

// 达标指标
const standardsIndicatorsPercent = {
  'widgetType': 'indicator',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [],
      'columns': [
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage',
            'toFixed': 2
          }
        }
      ]
    }
  ]
}

// 分级客户商业
const channelBusinessTable = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '0fee89e2-45a8-4aef-bc46-7b01042d559f',
      'rows': [
        {
          'field': 'companyName',
          'name': '客户名称'
        }
      ],
      'columns': [
        // {
        //   'field': 'salesTargetAmount',
        //   'name': '目标',
        //   'format': {
        //     'magnitude': 'tenThousand',
        //     'emptyValue': '-'
        //   }
        // },
        {
          'field': 'cumulativeCompletionAmount',
          'name': '累计完成(不含赠品)',
          'format': {
            'magnitude': 'tenThousand',
            'emptyValue': '-'
          }
        },
        // {
        //   'field': 'yearlySchedule',
        //   'name': '全年进度',
        //   'format': {
        //     'magnitude': 'percentage',
        //     'emptyValue': '-'
        //   }
        // },
        {
          'field': 'cumulativeCompletionAmount',
          'name': '去年同期(不含赠品)',
          'ratio': 'YOY.V',
          'format': {
            'magnitude': 'tenThousand',
            'emptyValue': '-'
          }
        },
        {
          'field': 'cumulativeCompletionAmount',
          'name': '同比去年',
          'ratio': 'YOY.R',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        }
      ],
      'totals': {
        'rowTotals': {
          'total': {
            'enable': true
          }
        },
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      'orders': [
        {
          'field': 'yearlySchedule',
          'mode': 'DESC'
        },
        {
          'field': 'cumulativeCompletionAmount',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

// 分级客户二级商业
const channelSecondaryBusinessTable = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '0fee89e2-45a8-4aef-bc46-7b01042d559f',
      'rows': [
        {
          'field': 'companyName',
          'name': '客户名称'
        }
      ],
      'columns': [
        {
          'field': 'cumulativeCompletionAmount',
          'name': '累计完成(含赠品)',
          'format': {
            'magnitude': 'tenThousand',
            'emptyValue': '-'
          }
        },
        {
          'field': 'cumulativeCompletionAmount',
          'name': '去年同期(含赠品)',
          'ratio': 'YOY.V',
          'format': {
            'magnitude': 'tenThousand',
            'emptyValue': '-'
          }
        },
        {
          'field': 'cumulativeCompletionAmount',
          'name': '同比去年',
          'ratio': 'YOY.R',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        }
      ],
      'totals': {
        'rowTotals': {
          'total': {
            'enable': true
          }
        },
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      'orders': [
        {
          'field': 'yearlySchedule',
          'mode': 'DESC'
        },
        {
          'field': 'cumulativeCompletionAmount',
          'mode': 'DESC'
        }
      ]
    }
  ]
}
// 分级客户KA连锁
const channelKaTable = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': 'd1c23b10-d124-49bd-bc66-a376fbc8b3bc',
      'rows': [
        {
          'field': 'companyName',
          'name': '客户名称'
        }
      ],
      'columns': [
        {
          'field': 'mainProductBrand',
          'name': '品规'
        },
        {
          'field': 'dragonPurchaseNumber',
          'name': '龙牡购进数量',
          'format': {
            'emptyValue': '-'
          }
        },
        {
          'field': 'dragonPurchaseNumber',
          'name': '去年同期',
          'ratio': 'YOY.V',
          'format': {
            'emptyValue': '-'
          }
        },
        {
          'field': 'dragonPurchaseNumber',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        },
        {
          'field': 'dragonFreebieAfterNumber',
          'name': '剔除赠品后数量',
          'format': {
            'emptyValue': '-'
          }
        },
        {
          'field': 'dragonFreebieAfterNumber',
          'name': '去年同期',
          'ratio': 'YOY.V',
          'format': {
            'emptyValue': '-'
          }
        },
        {
          'field': 'dragonFreebieAfterNumber',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        }
      ],
      'totals': {
        'rowTotals': {
          'total': {
            'enable': true
          }
        },
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      sortParams: [
        {
          sortFieldId: 'companyName',
          sortMethod: 'DESC',
          sortByMeasure: 'dragonFreebieAfterNumber',
          query: {
            'mainProductBrand': '龙牡60',
            [EXTRA_FIELD]: 'dragonFreebieAfterNumber'
          }
        },
        { 'sortFieldId': 'mainProductBrand', 'sortBy': ['龙牡60', '龙牡30'] }
      ]
    }
  ]
}

// 分级客户连锁
const channelChainTable = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': 'd1c23b10-d124-49bd-bc66-a376fbc8b3bc',
      'rows': [
        {
          'field': 'companyName',
          'name': '客户名称'
        }
      ],
      'columns': [
        {
          'field': 'mainProductBrand',
          'name': '品规'
        },
        {
          'field': 'dragonPurchaseNumber',
          'name': '龙牡购进数量(含赠品)',
          'format': {
            'emptyValue': '-'
          }
        },
        {
          'field': 'dragonPurchaseNumber',
          'name': '去年同期',
          'ratio': 'YOY.V',
          'format': {
            'emptyValue': '-'
          }
        },
        {
          'field': 'dragonPurchaseNumber',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage',
            'emptyValue': '-'
          }
        }
      ],
      'totals': {
        'rowTotals': {
          'total': {
            'enable': true
          }
        },
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      sortParams: [
        {
          // companyName 依据 总计 dragonFreebieAfterNumber& 升序 排序
          sortFieldId: 'companyName',
          sortMethod: 'DESC',
          sortByMeasure: 'dragonPurchaseNumber',
          query: {
            'mainProductBrand': '龙牡30',
            [EXTRA_FIELD]: 'dragonPurchaseNumber'
          }
        },
        { 'sortFieldId': 'mainProductBrand', 'sortBy': ['龙牡30', '龙牡60'] }
      ]
    }
  ]
}

const provinceSalesDetail = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [
        {
          'field': 'dept',
          'name': '销售公司'
        },
        {
          'field': 'province',
          'name': '省份'
        }
      ],
      'columns': [
        {
          'field': 'monthAmount',
          'name': '当月(元)',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'yearAmount',
          'name': '全年累计(元)',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'yearPercent',
          'name': '全年进度',
          'format': {
            'magnitude': 'percentage'
          }
        },
        {
          'field': 'yearAmount',
          'name': '去年同期(元)',
          'ratio': 'YOY.V',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'yearAmount',
          'ratio': 'YOY.R',
          'name': '同比去年',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'orders': [
        {
          'field': 'yearPercent',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

const provinceSalesTop = {
  'widgetType': 'bar',
  'cubes': [
    {
      'cubeId': '085b79b2-7749-4218-b0c3-96947f185a79',
      'rows': [
        {
          'field': 'province',
          'name': '省'
        }
      ],
      'columns': [
        {
          'field': 'yearAmount',
          'name': '全年累计',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'yearAmount',
          'name': '去年同期',
          'ratio': 'YOY.V',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'targetAmount',
          'name': '全年目标',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        }
      ],
      'orders': [
        {
          'field': 'yearPercent',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

const productCoverByProvinceTop = {
  'widgetType': 'bar',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [
        {
          'field': 'province',
          'name': '省'
        }
      ],
      'columns': [
        {
          'field': 'coveredClientNum',
          'name': '覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        }
      ],
      'orders': [
        {
          'field': 'coveredPercent',
          'mode': 'DESC'
        },
        {
          'field': 'coveredClientNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

const productCoverByProvinceDetail = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [
        {
          'field': 'dept',
          'name': '销售公司'
        },
        {
          'field': 'province',
          'name': '省份'
        }
      ],
      'columns': [
        {
          'field': 'coveredClientNum',
          'name': '覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'coveredPercent',
          'name': '覆盖率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'orders': [
        {
          'field': 'coveredPercent',
          'mode': 'DESC'
        },
        {
          'field': 'coveredClientNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

const deptProductsCoverByCity = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [
        {
          'field': 'province',
          'name': '省'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'coveredClientNum',
          'name': '覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'coveredPercent',
          'name': '覆盖率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'orders': [
        {
          'field': 'coveredPercent',
          'mode': 'DESC'
        },
        {
          'field': 'coveredClientNum',
          'mode': 'DESC'
        }
      ],
      sortParams: [
        { 'sortFieldId': 'channelType', 'sortBy': ['龙牡60总部', '龙牡60门店'] },
        {
          sortFieldId: 'province',
          sortMethod: 'DESC',
          sortByMeasure: 'coveredPercent',
          query: {
            'channelType': '龙牡60总部',
            [EXTRA_FIELD]: 'coveredPercent'
          }
        }
      ]
    }
  ]
}

const productsCoverByCity = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [
        {
          'field': 'city',
          'name': '城市'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'coveredClientNum',
          'name': '覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'coveredPercent',
          'name': '覆盖率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'orders': [
        {
          'field': 'coveredPercent',
          'mode': 'DESC'
        },
        {
          'field': 'coveredClientNum',
          'mode': 'DESC'
        }
      ],
      sortParams: [
        { 'sortFieldId': 'channelType', 'sortBy': ['龙牡60总部', '龙牡60门店'] },
        {
          sortFieldId: 'city',
          sortMethod: 'DESC',
          sortByMeasure: 'coveredPercent',
          query: {
            'channelType': '龙牡60总部',
            [EXTRA_FIELD]: 'coveredPercent'
          }
        }
      ]
    }
  ]
}

const productsCoverByCrownCity = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [
        {
          'field': 'district',
          'name': '区县'
        },
        {
          'field': 'dept',
          'name': '销售公司'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'coveredClientNum',
          'name': '覆盖数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'coveredPercent',
          'name': '覆盖率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'orders': [
        {
          'field': 'coveredPercent',
          'mode': 'DESC'
        },
        {
          'field': 'coveredClientNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

const productDistributionByProvinceTop = {
  'widgetType': 'bar',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'province',
          'name': '省'
        }
      ],
      'columns': [
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        }
      ],
      'orders': [
        {
          'field': 'distributionPercent',
          'mode': 'DESC'
        },
        {
          'field': 'distributionNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

const productDistributionByProvinceDetail = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'dept',
          'name': '销售公司'
        },
        {
          'field': 'province',
          'name': '省份'
        }
      ],
      'columns': [
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'orders': [
        {
          'field': 'distributionPercent',
          'mode': 'DESC'
        },
        {
          'field': 'distributionNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

const productStandardsByProvinceTop = {
  'widgetType': 'bar',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'province',
          'name': '省'
        }
      ],
      'columns': [
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        }
      ],
      'orders': [
        {
          'field': 'standardsPercent',
          'mode': 'DESC'
        },
        {
          'field': 'standardsNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}

const productStandardsByProvinceDetail = {
  'widgetType': 'table',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'dept',
          'name': '销售公司'
        },
        {
          'field': 'province',
          'name': '省份'
        }
      ],
      'columns': [
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'orders': [
        {
          'field': 'standardsPercent',
          'mode': 'DESC'
        },
        {
          'field': 'standardsNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}
// 部门分析区域铺货
const deptAreaDistribution = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'province',
          'name': '省'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage'
          }
        },
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      sortParams: [
        { 'sortFieldId': 'channelType', 'sortBy': ['龙牡60门店', '协议连锁门店', '单体药店'] },
        {
          sortFieldId: 'city',
          sortMethod: 'DESC',
          sortByMeasure: TOTAL_VALUE,
          query: {
            [EXTRA_FIELD]: 'distributionPercent'
          }
        }
      ]
    }
  ]
}
// 部门分析区域铺货
const deptAreaDistributionPuhuo = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'province',
          'name': '省'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      'orders': [
        {
          'field': 'distributionPercent',
          'mode': 'DESC'
        },
        {
          'field': 'distributionNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}
// 部门分析区域达标
const deptAreaDistributionDabiao = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'province',
          'name': '省'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      'orders': [
        {
          'field': 'standardsPercent',
          'mode': 'DESC'
        },
        {
          'field': 'standardsNum',
          'mode': 'DESC'
        }
      ]
    }
  ]
}
// 区域铺货
const areaDistribution = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'city',
          'name': '城市'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage'
          }
        },
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },

      sortParams: [
        { 'sortFieldId': 'channelType', 'sortBy': ['龙牡60门店', '协议连锁门店', '单体药店'] },
        {
          sortFieldId: 'city',
          sortMethod: 'DESC',
          sortByMeasure: TOTAL_VALUE,
          query: {
            [EXTRA_FIELD]: 'distributionNum'
          }
        }
      ]
    }
  ]
}

// 区域铺货
const areaDistributionPuhuo = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'city',
          'name': '城市'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      'orders': [
        {
          field: 'distributionPercent',
          mode: 'DESC'
        },
        {
          field: 'distributionNum',
          mode: 'DESC'
        }
      ]
    }
  ]
}

// 区域达标
const areaDistributionDabiao = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'city',
          'name': '城市'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      'orders': [
        {
          field: 'standardsPercent',
          mode: 'DESC'
        },
        {
          field: 'standardsNum',
          mode: 'DESC'
        }
      ]
    }
  ]
}
// 区域铺货下钻
const districtDistribution = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'district',
          'name': '区县'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage'
          }
        },
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      sortParams: [
        { 'sortFieldId': 'channelType', 'sortBy': ['龙牡60门店', '协议连锁门店', '单体药店'] },
        {
          // companyName 依据 总计 dragonFreebieAfterNumber& 升序 排序
          sortFieldId: 'district',
          sortMethod: 'DESC',
          sortByMeasure: TOTAL_VALUE,
          query: {
            [EXTRA_FIELD]: 'distributionPercent'
          }
        }
      ]
    }
  ]
}
// 区域铺货下钻
const districtDistributionPuhuo = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'district',
          'name': '区县'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'distributionNum',
          'name': '铺货数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'distributionPercent',
          'name': '铺货率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      'orders': [
        {
          field: 'distributionPercent',
          mode: 'DESC'
        },
        {
          field: 'distributionNum',
          mode: 'DESC'
        }
      ]
    }
  ]
}
// 区域达标下钻
const districtDistributionDabiao = {
  'widgetType': 'detailTable',
  'cubes': [
    {
      'cubeId': 'ab680e6f-7a0e-413b-adfa-898f1144d20c',
      'rows': [
        {
          'field': 'district',
          'name': '区县'
        }
      ],
      'columns': [
        {
          'field': 'channelType',
          'name': '渠道类型'
        },
        {
          'field': 'standardsNum',
          'name': '达标数',
          'format': {
            'magnitude': 'default',
            'thousandsSeparatorFlag': true
          }
        },
        {
          'field': 'standardsPercent',
          'name': '达标率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ],
      'totals': {
        'columnTotals': {
          'total': {
            'enable': true
          }
        }
      },
      'orders': [
        {
          field: 'standardsPercent',
          mode: 'DESC'
        },
        {
          field: 'standardsNum',
          mode: 'DESC'
        }
      ]
    }
  ]
}

const provinceMapCover = {
  'widgetType': 'map',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [
        {
          'field': 'city',
          'name': '市'
        }
      ],
      'columns': [
        {
          'field': 'coveredPercent',
          'name': '覆盖率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ]
    }
  ]
}
const provinceMapCoverCity = {
  'widgetType': 'map',
  'cubes': [
    {
      'cubeId': '1aa8499b-a134-4723-b7eb-0a59457599c4',
      'rows': [
        {
          'field': 'district',
          'name': '区县'
        }
      ],
      'columns': [
        {
          'field': 'coveredPercent',
          'name': '覆盖率',
          'format': {
            'magnitude': 'percentage'
          }
        }
      ]
    }
  ]
}

const cubeData = {
  jianminSendOut,
  businessProduct: {
    trackId: 'businessProduct',
    ...businessProduct
  },
  attractInvestmentProduct: {
    trackId: 'attractInvestmentProduct',
    ...attractInvestmentProduct
  },
  kaProduct: {
    trackId: 'kaProduct',
    ...kaProduct
  },
  saleCompany: {
    trackId: 'saleCompany',
    ...saleCompany
  },
  saleCompanyTable: {
    trackId: 'saleCompanyTable',
    ...saleCompanyTable
  },
  productPercent,
  YearAmount_YOY_R,
  yearPercent,
  productList2021: {
    trackId: 'productList2021',
    ...productList
  },
  productList2022: {
    trackId: 'productList2022',
    ...productList
  },
  productTable: {
    trackId: 'productTable',
    ...productTable
  },
  product60headquartersPercent: {
    trackId: 'product60headquartersPercent',
    ...coveredPercent
  },
  product60headquartersNumber: {
    trackId: 'product60headquartersNumber',
    ...coveredNumber
  },
  product60storesPercent: {
    trackId: 'product60storesPercent',
    ...coveredPercent
  },
  product60storesNumber: {
    trackId: 'product60storesNumber',
    ...storesCoveredNumber
  },
  product60headquartersCoverList: {
    trackId: 'product60headquartersCoverList',
    ...coverList
  },
  product60storesCoverList: {
    trackId: 'product60storesCoverList',
    ...coverList
  },
  product30controllableHeadquartersPercent: {
    trackId: 'product30controllableHeadquartersPercent',
    ...coveredPercent
  },
  product30controllableHeadquartersNumber: {
    trackId: 'product30controllableHeadquartersNumber',
    ...coveredNumber
  },
  product30controllableStoresNumber: {
    trackId: 'product30controllableStoresNumber',
    ...storesCoveredNumber
  },
  product30controllableStoresPercent: {
    trackId: 'product30controllableStoresPercent',
    ...coveredPercent
  },
  product30controllableHeadquartersCoverList: {
    trackId: 'product30controllableHeadquartersCoverList',
    ...coverList
  },
  product30controllableStoresCoverList: {
    trackId: 'product30controllableStoresCoverList',
    ...coverList
  },
  product30notControllableHeadquartersPercent: {
    trackId: 'product30notControllableHeadquartersPercent',
    ...coveredPercent
  },
  product30storeHeadquartersPercent: {
    trackId: 'product30storeHeadquartersPercent',
    ...coveredPercent
  },
  product30notControllableHeadquartersNumber: {
    trackId: 'product30notControllableHeadquartersNumber',
    ...coveredNumber
  },
  product30storeHeadquartersNumber: {
    trackId: 'product30storeHeadquartersNumber',
    ...storeCoveredNumber
  },
  product30notControllableHeadquartersCoverList: {
    trackId: 'product30notControllableHeadquartersCoverList',
    ...coverList
  },
  product30storeHeadquartersCoverList: {
    trackId: 'product30storeHeadquartersCoverList',
    ...coverList
  },
  product60storesDistributionNum: {
    trackId: 'product60storesDistributionNum',
    ...distributionNum
  },
  product30controllableStoresDistributionNum: {
    trackId: 'product30controllableStoresDistributionNum',
    ...distributionNum
  },
  product30notControllableStoresDistributionNum: {
    trackId: 'product30notControllableStoresDistributionNum',
    ...distributionNum
  },
  product60storesStandardsNum: {
    trackId: 'product60storesStandardsNum',
    ...standardsNum
  },
  product30controllableStoresStandardsNum: {
    trackId: 'product30controllableStoresStandardsNum',
    ...standardsNum
  },
  product30notControllableStoresStandardsNum: {
    trackId: 'product30notControllableStoresStandardsNum',
    ...standardsNum
  },
  distributionIndicators: {
    trackId: 'distributionIndicators',
    ...distributionIndicators
  },
  distributionIndicatorsNum: {
    trackId: 'distributionIndicatorsNum',
    ...distributionIndicatorsNum
  },
  product60storesDistributionIndicatorsNum: {
    trackId: 'product60storesDistributionIndicatorsNum',
    ...distributionIndicatorsNum
  },
  product30controllableStoresDistributionIndicatorsNum: {
    trackId: 'product30controllableStoresDistributionIndicatorsNum',
    ...distributionIndicatorsNum
  },
  product30notControllableStoresDistributionIndicatorsNum: {
    trackId: 'product30notControllableStoresDistributionIndicatorsNum',
    ...distributionIndicatorsNum
  },
  distributionIndicatorsPercent: {
    trackId: 'distributionIndicatorsPercent',
    ...distributionIndicatorsPercent
  },
  product60storesDistributionIndicatorsPercent: {
    trackId: 'product60storesDistributionIndicatorsPercent',
    ...distributionIndicatorsPercent
  },
  product30controllableStoresDistributionIndicatorsPercent: {
    trackId: 'product30controllableStoresDistributionIndicatorsPercent',
    ...distributionIndicatorsPercent
  },
  product30notControllableStoresDistributionIndicatorsPercent: {
    trackId: 'product30notControllableStoresDistributionIndicatorsPercent',
    ...distributionIndicatorsPercent
  },
  standardsIndicators: {
    trackId: 'standardsIndicators',
    ...standardsIndicators
  },
  standardsIndicatorsNum: {
    trackId: 'standardsIndicatorsNum',
    ...standardsIndicatorsNum
  },
  product60storesStandardsIndicatorsNum: {
    trackId: 'product60storesStandardsIndicatorsNum',
    ...standardsIndicatorsNum
  },
  product30controllableStoresStandardsIndicatorsNum: {
    trackId: 'product30controllableStoresStandardsIndicatorsNum',
    ...standardsIndicatorsNum
  },
  product30notControllableStoresStandardsIndicatorsNum: {
    trackId: 'product30notControllableStoresStandardsIndicatorsNum',
    ...standardsIndicatorsNum
  },
  standardsIndicatorsPercent: {
    trackId: 'standardsIndicatorsPercent',
    ...standardsIndicatorsPercent
  },
  product60storesStandardsIndicatorsPercent: {
    trackId: 'product60storesStandardsIndicatorsPercent',
    ...standardsIndicatorsPercent
  },
  product30controllableStoresStandardsIndicatorsPercent: {
    trackId: 'product30controllableStoresStandardsIndicatorsPercent',
    ...standardsIndicatorsPercent
  },
  product30notControllableStoresStandardsIndicatorsPercent: {
    trackId: 'product30notControllableStoresStandardsIndicatorsPercent',
    ...standardsIndicatorsPercent
  },
  channelBusinessTable: {
    trackId: 'channelBusinessTable',
    ...channelBusinessTable
  },
  channelSecondaryBusinessTable: {
    trackId: 'channelSecondaryBusinessTable',
    ...channelSecondaryBusinessTable
  },
  channelKaTable: {
    trackId: 'channelKaTable',
    ...channelKaTable
  },
  channelChainTable: {
    trackId: 'channelChainTable',
    ...channelChainTable
  },
  provinceSalesDetail: {
    trackId: 'provinceSalesDetail',
    ...provinceSalesDetail
  },
  provinceSalesTop: {
    trackId: 'provinceSalesTop',
    ...provinceSalesTop
  },
  productCoverByProvinceTop: {
    trackId: 'productCoverByProvinceTop',
    ...productCoverByProvinceTop
  },
  productCoverByProvinceDetail: {
    trackId: 'productCoverByProvinceDetail',
    ...productCoverByProvinceDetail
  },
  deptProductsCoverByCity: {
    trackId: 'deptProductsCoverByCity',
    ...deptProductsCoverByCity
  },
  productsCoverByCity: {
    trackId: 'productsCoverByCity',
    ...productsCoverByCity
  },
  productsCoverByCrownCity: {
    trackId: 'productsCoverByCrownCity',
    ...productsCoverByCrownCity
  },
  productDistributionByProvinceTop: {
    trackId: 'productDistributionByProvinceTop',
    ...productDistributionByProvinceTop
  },
  productDistributionByProvinceDetail: {
    trackId: 'productDistributionByProvinceDetail',
    ...productDistributionByProvinceDetail
  },
  productStandardsByProvinceTop: {
    trackId: 'productStandardsByProvinceTop',
    ...productStandardsByProvinceTop
  },
  productStandardsByProvinceDetail: {
    trackId: 'productStandardsByProvinceDetail',
    ...productStandardsByProvinceDetail
  },
  areaDistribution: {
    trackId: 'areaDistribution',
    ...areaDistribution
  },
  areaDistribution铺货: {
    trackId: 'areaDistribution铺货',
    ...areaDistributionPuhuo
  },
  areaDistribution达标: {
    trackId: 'areaDistribution达标',
    ...areaDistributionDabiao
  },
  districtDistribution: {
    trackId: 'districtDistribution',
    ...districtDistribution
  },
  districtDistribution铺货: {
    trackId: 'districtDistribution铺货',
    ...districtDistributionPuhuo
  },
  districtDistribution达标: {
    trackId: 'districtDistribution达标',
    ...districtDistributionDabiao
  },
  deptAreaDistribution: {
    trackId: 'deptAreaDistribution',
    ...deptAreaDistribution
  },
  deptAreaDistribution铺货: {
    trackId: 'deptAreaDistribution铺货',
    ...deptAreaDistributionPuhuo
  },
  deptAreaDistribution达标: {
    trackId: 'deptAreaDistribution达标',
    ...deptAreaDistributionDabiao
  },
  provinceMapCover: {
    trackId: 'provinceMapCover',
    ...provinceMapCover
  },
  provinceMapCoverCity: {
    trackId: 'provinceMapCover',
    ...provinceMapCoverCity
  }
}

function handleCubeReq (trackId, req) {
  const params = JSON.parse(JSON.stringify(cubeData[trackId]))
  params.cubes[0].filters = keysIn(req).flatMap(key => {
    // TODO: 目前只处理数组  除数组外的其他类型一律当单值处理
    if (req[key] instanceof Array) {
      return {
        field: key,
        mode: 'IN',
        values: req[key]
      }
    }
    if ((trackId === 'channelKaTable' || trackId === 'channelBusinessTable' || trackId === 'channelSecondaryBusinessTable') && key === 'month') {
      return {
        field: key,
        mode: '<=',
        values: [req[key]]
      }
    }
    // if (['product60headquartersNumber', 'product60headquartersPercent', 'product60storesNumber', 'product60storesPercent', 'product60headquartersCoverList',
    //   'product60storesCoverList', 'product30controllableHeadquartersNumber', 'product30controllableHeadquartersPercent', 'product30controllableStoresNumber',
    //   'product30controllableStoresPercent', 'product30controllableHeadquartersCoverList', 'product30controllableStoresCoverList', 'product30notControllableHeadquartersNumber',
    //   'product30notControllableHeadquartersPercent', 'product30notControllableHeadquartersCoverList', 'product30storeHeadquartersNumber', 'product30storeHeadquartersPercent',
    //   'product30storeHeadquartersCoverList', 'productsCoverByCity', 'productsCoverByCrownCity', 'deptProductsCoverByCity'].indexOf(trackId) > -1 && key === 'month') {
    //   return {
    //     field: key,
    //     mode: '>=',
    //     values: [req[key]]
    //   }
    // }
    if (['distributionIndicators', 'standardsIndicators', 'product60storesDistributionNum', 'product30controllableStoresDistributionNum', 'product30notControllableStoresDistributionNum',
      'product60storesStandardsNum', 'product30controllableStoresStandardsNum', 'product30notControllableStoresStandardsNum',
      'productDistributionByProvinceDetail', 'productDistributionByProvinceTop',
      'productStandardsByProvinceDetail', 'productStandardsByProvinceTop',
      'areaDistribution', 'districtDistribution', 'deptAreaDistribution'].indexOf(trackId) > -1 && key === 'year') {
      return {
        field: key,
        mode: '>=',
        values: [req[key]]
      }
    }
    return {
      field: key,
      mode: '=',
      values: [req[key]]
    }
  })
  return params
}

export function biData (trackId, req) {
  return request({
    url: '/v1/bi/data',
    method: 'post',
    data: handleCubeReq(trackId, req)
  })
}
